const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '基本信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
        size: 'medium',
        text: '附件',
    },
},
{
    component: 'file-list',
    options: {
      groupId: '',
    },
},
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '中标候选人',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '候选人',
      data: {},
    },
  },
  // {
  //     component: 'ZlmTitle',
  //     options: {
  //         size: 'medium',
  //         text: '审核记录',
  //     },
  // },
  // {
  //     component: 'ZlmTabDetail',
  //     options: {
  //         title: '记录',
  //         data: [],
  //     },
  // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')
const { getZhongBiaoTypeName } = require('../zhongBiaoType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request
        .post(
          `/transformToAfter/app/track/dbOverview`,
          {
            bdGuid: this.$route.query.id,
            ggBdGuid: this.$route.query.ggBDGuid,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.getZbrDetail(res.data.pbBaoGaoGuid)
        })
    },
    getZbrDetail(guid) {
      this.$request
        .post(`/transformToAfter/app/determine/bid/zbInfoView`, {
          bdGuid: this.$route.query.id,
          guid: guid,
        })
        .then((res) => {
          if (res.data) {
            this.config[3].options.groupId = res.data.fujianGuid
            this.config[1].options.data = {
              标段名称: res.data.bdName,
              标段编号: res.data.bdBH,
              项目类型: getProjectTypeName(res.data.zbxmlx),
              采购方式: getPurchaseTypeName(res.data.cgFangShi),
              中标形式: getZhongBiaoTypeName(res.data.zbXingShi),
              评标时间: this.$util.timeFormatter(res.data.pbTime),
              评标报告: '',
            }
            if (
              res.data.candidateListVoList &&
              res.data.candidateListVoList.length > 0
            ) {
              this.config[5].options.data = res.data.candidateListVoList.map(
                (t) => ({
                  中标候选人: t.tbrName,
                  '中标金额（元': t.zhongBiaoJia,
                  质量: t.wjzhiLiang,
                  '工期（天）': t.wjgongQi,
                  项目负责人: t.fuZeRen,
                  负责人证书: t.fzrZhengShu,
                  资格能力条件: t.ziGeNengLi,
                  公示名称: res.data.gongshiName,
                  公示开始时间: this.$util.timeFormatter(
                    res.data.gongShiStartTime,
                  ),
                  公示结束时间: this.$util.timeFormatter(
                    res.data.gongShiEndTime,
                  ),
                  备注: res.data.beizhu,
                  是否对外公示: res.data.isOutGongShi ? '是' : '否',
                }),
              )
            }
            if (res.data.pbbgFileGuid) {
              this.$request
                .post(`/transformToAfter/guotou-file-business/getByFileGuid`, {
                  fileInfoGuid: res.data.pbbgFileGuid,
                })
                .then((res2) => {
                  this.config[1].options.data['评标报告'] = res2.data.name
                  // http://114.67.239.111:8043/file-web/downloadFile?guid=93f437f7-7924-4377-90e2-91b3d0d66a7d&token=fca3a63e-9d8c-4f39-b2ee-427236c65980"
                })
            }
          }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
